import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Button } from "@mui/material";
import { RpcError } from "grpc-web";
import { postTrack } from "../../services/trackService";
import { Track, TrackState } from "../../proto/api_pb";
import useGetValidAccessToken from "../../hooks/useGetValidAccessToken";
import Mixpanel from "../../utils/mixpanel";
import { modalContainerStyles, publishPermissionModalStyles } from "./styles";

export const PublishPermissionModal: React.FC<{
  track: Track | undefined;
  open: boolean;
  handleFetch: (() => Promise<void>) | undefined;
  setIsPublishModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  makeRefEmpty: () => void;
}> = ({ open, setIsPublishModalOpen, track, handleFetch, makeRefEmpty }) => {
  const { getValidAccessToken } = useGetValidAccessToken();

  const handlePublish = async () => {
    makeRefEmpty();
    try {
      if (track) {
        track.setState(TrackState.TRACK_STATE_PUBLISHED);
        const postTrackResponse = await postTrack(
          track,
          await getValidAccessToken()
        );
        Mixpanel.track("published_track", {
          genre: track.getSongMetadata()?.getGenre(),
        });
        setIsPublishModalOpen(false);
        if (handleFetch) {
          handleFetch();
        }
        if (postTrackResponse instanceof RpcError) {
          //TODO: handle api exception gracefully with error modal, etc
          throw postTrackResponse;
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={() => {}}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalContainerStyles}>
          <Typography variant="h6">
            Do you want to make this track public? Making this track public will
            make it visible to all users on your profile page.
          </Typography>
          <Box sx={publishPermissionModalStyles.buttonContainer}>
            <Button
              onClick={handlePublish}
              sx={publishPermissionModalStyles.button}
            >
              Confirm
            </Button>
            <Button
              onClick={() => setIsPublishModalOpen(false)}
              sx={publishPermissionModalStyles.button}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};
